import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-avoir-tab-content',
  templateUrl: './avoir-tab-content.component.html',
  styleUrls: ['./avoir-tab-content.component.scss']
})
export class AvoirTabContentComponent implements OnInit {
    status: string = 'Tous';

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.status = this.route.snapshot.data['status'] || 'Tous';
    }
}
